const DEFAULT_CHANNEL = "ydemo";

const HostChannelMaps = {
  "dev-consumer-y.charmdeer.com": DEFAULT_CHANNEL
};

export const getChannelKeyByHost = () => {
  const host = window.location.host;
  return HostChannelMaps[host] || DEFAULT_CHANNEL;
};
